module.exports = __webpack_public_path__ + "assets/img/bf.15f19c42.png";